import loadable from '@loadable/component'

export default [
  {
    path: '/chat/cp',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-chat-cp" */ '~/pages/chat/cp')
    ),
  },
]
